import React from 'react'
import { connect } from 'react-redux'
import { format } from 'date-fns'

import { LgySection } from 'app/components/util/lgy-section/LgySection'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import LgyField from 'app/components/util/lgy-field/LgyField'
import { readableStringForHowLongBetweenTwoDates } from 'app/utils/dateTimeUtils'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import ReactMarkdown from 'react-markdown'

const JobRun = ({ jobName, run, isLoading }) => {
  const jobRunTimeDisplayString = run.endDate ? readableStringForHowLongBetweenTwoDates(run.startDate, run.endDate) : readableStringForHowLongBetweenTwoDates(run.startDate, new Date())
  return <LgySection header={`${jobName} #${run.id} Details`}>
    <LgyField label='Request UUID' value={run.requestUuid} />
    <LgyField label='Result' value={run.endDate === null
      ? 'Running'
      : run.success
        ? 'Success'
        : 'Failure'} />
    <LgyField label='Start date' value={format(run.startDate, 'M/d/yyyy h:mm aa', { awareOfUnicodeTokens: true })} />
    <LgyField label='End date' value={run.endDate ? format(run.endDate, 'M/d/yyyy h:mm aa', { awareOfUnicodeTokens: true }) : ''} />
    <LgyField label='Run time' value={jobRunTimeDisplayString} />
    <LgyField label='Started by' inlineChildren={true}>
      <LgyLink to={`/lgyhub/admin/users/${run.userStartedById}`}>{run.userStartedBy}</LgyLink>
    </LgyField>
    <div className='job-run-details'>
      <ReactMarkdown source={run.details} />
    </div>
    <div className='job-run-files'>
      <table>
        <caption>Job Files</caption>
        <thead>
          <tr>
            <th scope='col'>File Name</th>
            <th scope='col'>Processed Date</th>
            <th scope='col'>Direction</th>
            <th scope='col'>Status</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <tr><td colSpan='4'><LgyLoadingIcon /></td></tr>}
          {!isLoading && run.files.length < 1 && <tr><td colSpan='4'>No files found.</td></tr>}
          {run.files.map(file =>
            <tr key={file.id}>
              <th scope='row'><a href={`/lgyhub/api/jobs/${file.jobName}/files/${file.id}`}>{file.fileName}</a></th>
              <td>{format(file.processedDate, 'M/d/yyyy h:mm aa', { awareOfUnicodeTokens: true })}</td>
              <td>{file.direction}</td>
              <td>{file.status}</td>
            </tr>)}
        </tbody>
      </table>
    </div>
  </LgySection>
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.jobState.hasOwnProperty(`${ownProps.jobName}IsLoading`) ? state.jobState[`${ownProps.jobName}IsLoading`] : false,
})

export default connect(mapStateToProps)(JobRun)